var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXcad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedXcad0)",
    d: "m10.142 11.618l-2.506-5.19h3.627l1.276 3.04h.032l2.334-3.04h3.738l-4.496 5.408l2.665 5.736H13.06l-1.372-3.492h-.032L8.99 17.572H5.143z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedXcad0",
    x1: 11.892,
    x2: 11.892,
    y1: 17.572,
    y2: 6.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#FD6422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FC194A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#FC125F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B2AA6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXcad);
export default __webpack_public_path__ + "static/media/xcad.d58a146e3d60d92f9211da80ed05dcc1.svg";
export { ForwardRef as ReactComponent };